import { ListenIcon } from './icons/Listen';
import { ReadIcon } from './icons/Read';
import { WriteIcon } from './icons/Write';

export const mapPracticeMethodToIcon = {
  'Watch/Read': ReadIcon,
  Listen: ListenIcon,
  Write: WriteIcon,
};
